import { AdaptiveRespuestaDTO } from './adaptive.respuesta.dto'

export class Adaptive{
    constructor(
        public examen: string,
        public prueba: string,
        public credencial: string,
        public respuestas: AdaptiveRespuestaDTO[]
    ){}
}